import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { OtSlots } from '../common/ot-slot-model';
import _moment from 'proxies/dayjs';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { OtService } from '../common/ot.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { LoaderService } from 'src/modules/base/services/loader.service';
import BaseDecorator from 'src/modules/base/base-decorator';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-ot-slots-view',
    templateUrl: './ot-slots-view.component.html',
    styleUrls: ['./ot-slots-view.component.scss'],
    standalone: false
})
export class OtSlotsViewComponent extends BaseDecorator implements OnInit {
  @Input() patientInputData;
  @Input() cArmInputArray;
  @Input() showButton: boolean = true;
  @Output() emitArray = new EventEmitter<any>();
  otSlots: OtSlots;
  OTName: any;
  locale = {
    "format": "DD/MM/YYYY hh:mm:ss"
  }
  doctor_id: void;
  doctorSlots: any;
  colorScheme: any = { "Slot Available": { "border": "2px solid #9b9b9b", "background": "#fff" }, "Single slot booked": { "border": "2px solid #FB9026", "background": "#FFFFF" }, "Over Booking Slot available": { "border": "2px solid #FB9026", "background": "#FB9026" }, "Slot full": { "border": "2px solid #B8E986", "background": "#B8E986" }, "VIP booking": { "border": "2px solid #4A90E2", "background": "#B8E986" }, "OT booking": { "border": "2px solid #35C1B8", "background": "#35C1B8" }, "Off & others": { "border": "2px solid #C17FCE", "background": "#C17FCE" } }
  machineName: any;
  machineSlots: any;
  equipmentName: any;
  machineData: any;
  showDateTime: boolean = true;
  config = {
    "add_required": true,
    "table": true,
    "tile": false,
  }
  self: this;
  showCArm: boolean = false;
  finalArray: any = [];
  patientData: any;
  question: any = {};
  schedulable: boolean;
  cArmArray: any = [];
  dialogData: any;
  bloodData: any = [];
  machineServiceItemCode: any;
  numKey: any;
  additionalSurgeryResource: string;
  otObject: any;

  constructor(
    public route: ActivatedRoute,
    private baseService: BaseService,
    private dialogConfig: DialogConfig,
    private loader: LoaderService,
    private alert: AlertsService,
    private otService: OtService,
    public dialog: DialogRef,
  ) {
    super(route, 'OtSlotsViewComponent');
    this.self = this;
    this.otSlots = new OtSlots()
  }

  ngOnInit(): void {
    if (this.dialogConfig) {
      this.dialogData = this.dialogConfig.data
    }
    this.otSlots.currentDate = _moment().valueOf();
    // if (this.dialogData == undefined) {
    //   this.showDateTime = false;
    // }
    if (this.dialogData != undefined && this.dialogData.blood_required_details != undefined) {
      this.bloodData = this.dialogData.blood_required_details;
      this.showDateTime = false;
    }
    if (this.dialogData != undefined && this.dialogData.surgeryDetail != undefined) {
      this.showDateTime = false;
      if (this.dialogData.additionalSurgeryData != "") {
        this.cArmArray = this.dialogData.additionalSurgeryData;
      }
      if (this.dialogData.surgeryDetail.surgery_type == 'OT' || this.dialogData.surgeryDetail.surgery_type == 'ot')
        this.additionalSurgeryResource = "additional_surgery"
      else
        this.additionalSurgeryResource = "additional_surgery_cathlab"
    }
    if (this.dialogConfig.data != undefined) {
      this.otSlots.surgery_grade_id = this.dialogConfig.data.surgery_grade_id;
      this.doctor_id = this.dialogConfig.data.doctorId;
      if (this.otSlots.surgery_grade_id != undefined) {
        this.getSurgeryGradeData();
        this.getOTList();
      }
      if (this.doctor_id != undefined) {
        this.hasDoctorSlots();
      }
    }
    setTimeout(() => {
      if (this.patientInputData) {
        this.dialogConfig['data'] = {
          "patientData": this.patientInputData,
          "cArmArray": this.cArmInputArray
        }
        this.dialogData = this.dialogConfig.data
      }
      if (this.dialogData != undefined && this.dialogConfig.data.patientData != undefined && this.dialogConfig.data.surgery_grade_id == undefined && this.dialogConfig.data.doctorId == undefined) {
        this.patientData = this.dialogConfig.data.patientData;
        this.showCArm = true;
        this.showDateTime = false;
        this.question.expression = "!items.find(key=>key.service_id==item.service_id && key.machine_id==item.machine_id)"
        this.question.hideEdit = true
        if (this.dialogConfig.data.cArmArray != "") {
          this.cArmArray = this.dialogConfig.data.cArmArray;
        }
      }
    }, 5000);
  }

  /// Decorator 
  valueChangeEnd(e: any, formObj) {
    if (this.dialogData != undefined && this.dialogData.showSurgery) {
      if (formObj.form.value.surgeon_details != undefined && formObj.form.value.surgeon_details.length != 0) {
        let num: any;
        for (let i = 0; i < formObj.form.controls.surgeon_details.value.length; i++) {
          if (formObj.form.controls.surgeon_details.value[i].is_surgeon == true) {
            num = 1;
            break;
          }
          else
            num = 0;
        }
        if (num == 1 && formObj.form.controls.surgeon_details != undefined) {
          setTimeout(() => {
            formObj.form.controls.surgeon_details.question_component.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = false;
          }, 600)
        }
        else if (num == 0 && formObj.form.controls.surgeon_details != undefined) {
          formObj.form.controls.surgeon_details.question_component.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = true;
        }
        this.numKey = num;
      }
      else if (formObj.form.controls.surgeon_details != undefined && formObj.form.controls.surgeon_details.value.length == 0 && formObj.form.controls.surgeon_details.question_component != undefined) {
        formObj.form.controls.surgeon_details.question_component.formService.compositeQuestionMapping.surgeon_details.is_surgeon.visible = true;
        this.numKey = 0;
      }
    }
  }
  valueChangeStart(e: any, obj) {
    if (this.showCArm) {
      if (obj.form.controls['service_id'].value == '' && !obj.form._manualChange) {
        let filter = {
          "filter": "applicable_for_ot:true"
        }
        this.baseService.getData(filter, "", "equipment_detail", "facility-management", "GET_ALL").subscribe(
          res => {
            this.equipmentName = res.resource;
        //    obj.form.controls.service_id.setValue(this.equipmentName[0].equipment_id)
          }
        )
      }
      if (e.question && e.question.key == 'service_id' && obj.form.controls['service_id'].value != '') {
        let queryId = this.patientData.patientType == 'OP' ? 'GET_SERVICE_ITEM_PRICE' : 'GET_SERVICE_ITEM_PRICE_FROM_BILLING';
        let resource = this.patientData.patientType == 'OP' ? 'tariff_service_item' : 'billing_item';
        let application = this.patientData.patientType == 'OP' ? 'facility-management' : 'billing';
        let args = {
          args: `serviceId:${obj.form.controls['service_id'].value},payer_id:${this.patientData.payer_id},uhId:${this.patientData.uhId},admissionId:${this.patientData.encounter_id},patient_id:${this.patientData.patient_id},billingCategoryId:${this.patientData.billing_category_id},quantity:1,servicePriorityCode:routine,serviceType_code:equipment,care_type::${this.patientData.care_type},serviceType:equipment,priorityCode:routine`
        }
        this.baseService.getData(args, "", resource, application, queryId).subscribe(
          res => {
            if (res.errCode == -1) {
              this.alert.error(res.message);
              obj.form.controls['service_id'].setValue("");
              obj.form.controls['service_id'].updateValueAndValidity()
            }
            else if (res.errCode == 0 && res.resource.length == 0) {
              //this.formService.alerts.error("Service/Price not configured for selected criteria");
              this.alert.error(`Service/Price not configured for selected criteria.`)
              obj.form.controls['service_id'].setValue("");
              obj.form.controls['service_id'].updateValueAndValidity()
            }
            else {
              let data = this.equipmentName.find(x => x.equipment_id == obj.form.controls['service_id'].value);
              if (data) {
                obj.form.controls["machine_id"].question_component.question.options = data != undefined ? data.machine_details : [];
            //    obj.form.controls["machine_id"].setValue(data.machine_details[0].id)
            //    obj.form.controls["machine_name"].setValue(data.machine_details[0].text)
                this.machineAutoSelect(obj);
              }
              let filter = {
                args: "id:" + obj.form.controls['service_id'].value
              }
              this.baseService.getData(filter, "", "catalog_entry", "facility-management", "GET_BY_ID").subscribe(
                res => {
                  if (res.errCode == 0 && res.resource.length > 0) {
                    let resource = res.resource[0];
                    obj.form.controls.serviceItemCode.setValue(resource.identifier)
                    obj.form.controls.serviceType_Id.setValue(resource.serviceType_Id)
                    obj.form.controls.serviceType.setValue(resource.serviceType)
                    obj.form.controls.serviceItemName.setValue(resource.name)
                    obj.form.controls.serviceType_code.setValue(resource.serviceType_code)
                    obj.form.controls.name.setValue(resource.name)
                  }
                })
            }
          })
      }
      if (e.question && e.question.key == 'machine_id' && obj.form.controls['machine_id'].value != '') {
        this.machineAutoSelect(obj);
      }
      if (e.question && e.question.key == 'machine_id' && obj.form.controls['machine_id'].value == '') {
        this.showDateTime = false;
      }
    }
    if (this.dialogData != undefined && this.dialogData.showSurgery) {
      if (e.question && e.question.key == 'department_id' && this.dialogData.surgeryDetail && this.dialogData.surgeryDetail.encounter_id != '') {
        obj.form.controls["diagnosis"].question_component.question.datasource = {
          "application": "emr",
          "resource": "condition_diagnosis_main",
          "query_id": "GET_BY_CONDITIONDIAGNOSIS",
          "args": "encounter_id:" + this.dialogData.surgeryDetail.encounter_id
        };
      }
      if (e.question && e.question.key == 'surgery_grade_id' && obj.form.controls['surgery_grade_duration']) {
        if (obj.form.controls['surgery_grade_id'].value) {
          this.baseService.get("GET_BY_ID", "id:" + obj.form.controls['surgery_grade_id'].value, "surgery_grade_master", "facility-management").subscribe((res: any) => {
            if (res.errCode == 0 && res.resource.length) {
              obj.form.controls['surgery_grade_duration'].setValue(res.resource[0].duration_min)
            }
            else {
              obj.form.controls['surgery_grade_duration'].setValue('')
            }
          })
        }
        else {
          obj.form.controls['surgery_grade_duration'].setValue('')
        }
      }
      if (e.question && e.question.key == 'serviceItemId' && obj.form._manualChange && obj.form.controls['priority_id'].value == '') {
        let args = {
          "args": "facility_master_type:SERVICEPRIORITY,serviceType_code:surgery",
        }
        this.baseService.getData(args, "", "facility_master", "facility-management", "GET_SERVICE_PRIORITY").subscribe(
          res => {
            obj.form.controls.priority_id.setValue(res.resource[0].id)
            obj.form.controls.priority.setValue(res.resource[0].service_priority)
            obj.form.controls.priorityCode.setValue(res.resource[0].service_priority_id)
          }
        )
      }
      if (e.question && e.question.key == 'serviceItemId' && e.val != '' && obj.form._manualChange) {
        // let queryId = this.dialogData.surgeryDetail.patientType == 'OP'?'GET_SERVICE_ITEM_PRICE':'GET_SERVICE_ITEM_PRICE_FROM_BILLING';
        //     let resource = this.dialogData.surgeryDetail.patientType == 'OP'?'tariff_service_item':'billing_item';
        //     let application = this.dialogData.surgeryDetail.patientType == 'OP'?'facility-management':'billing';
        let args = {
          args: `serviceId:${obj.form.controls['serviceItemId'].value},payer_id:${this.dialogData.surgeryDetail.payer_id},uhId:${this.dialogData.surgeryDetail.uhId},admissionId:${this.dialogData.surgeryDetail.encounter_id},patient_id:${this.dialogData.surgeryDetail.patient_id},billingCategoryId:${this.dialogData.surgeryDetail.billing_category_id},quantity:1,serviceType_code:surgery,care_type::${this.dialogData.surgeryDetail.care_type},serviceType:surgery`
        }
        this.baseService.getData(args, "", "tariff_service_item", "facility-management", "GET_SERVICE_ITEM_PRICE").subscribe(
          res => {
            if (res.errCode == -1) {
              this.alert.error(res.message);
              obj.form.controls['serviceItemId'].setValue("");
            }
            else if (res.errCode == 0 && res.resource.length == 0) {
              this.alert.error("Service/Price not configured for selected criteria");
              obj.form.controls['serviceItemName'].setValue("");
            }
          })
      }
    }
  }
  machineSlotResult(event: any) {
    this.machineData = event
  }

  beforeSubmitValidation(result: any, currentBtnVal: any) {
    if (this.dialogData.showSurgery) {
      if (result['currentForm']['controls'].mandatory_component && result['currentForm']['controls'].mandatory_component.value == "") {
        delete result['currentForm']['controls'].mandatory_component
      }
      if (result.currentForm.controls.surgeon_details != undefined && result.currentForm.controls.surgeon_details.value.length != 0) {
        if (this.numKey == 0) {
          this.alert.error("Please Select Main Surgeon");
          return false;
        }
      }
      if (result.currentForm.controls.surgeon_details != undefined && result.currentForm.controls.surgeon_details.value.length == 0) {
        this.alert.error("Please Select Main Surgeon");
        return false;
      }
    }
    if (this.dialogData.showBlood && this.bloodData.length != 0) {
      if (result.currentForm.value.blood_group != this.bloodData[0].blood_group) {
        this.alert.error("You can not add blood component with different blood group");
        return false;
      }
    }
    return true
  }

  machineAutoSelect(obj: any) {
    this.otSlots.machineId = obj.form.controls['machine_id'].value;
    let data = {
      filter: "id:" + obj.form.controls['machine_id'].value
    }
    this.baseService.getData(data, "", "machine", "facility-management", "GET_PAGE").subscribe(
      res => {
        if (res.errCode == 0) {
          if (res.resource[0].is_machine_schedule == true) {
            this.machineServiceItemCode = res.resource[0].serviceType_code
            this.getMachineSlots(this.otSlots.currentDate, obj.form.controls['machine_id'].value);
            this.showDateTime = true;
            obj.form.controls["qty"].question_component.question.disabled = true;
            obj.form.controls["qty"].setValue(1);
            obj.form.controls["timeBased"].setValue(true);
            this.schedulable = true;
          }
          else {
            obj.form.controls["qty"].question_component.question.disabled = false;
            obj.form.controls["timeBased"].setValue(false);
            obj.form.controls["serviceDate"].setValue(this.otSlots.currentDate);
            obj.form.controls["serviceEndTime"].setValidators(null)
            obj.form.controls["serviceStartTime"].setValidators(null)
            obj.form.controls["serviceEndTime"].updateValueAndValidity()
            obj.form.controls["serviceStartTime"].updateValueAndValidity()
            obj.form.controls["serviceDate"].setValidators(null)
            obj.form.controls["serviceDate"].updateValueAndValidity()
            this.showDateTime = false;
            this.schedulable = false
          }
        }
      }
    )
  }

  public getSurgeryGradeData() {
    var hasArgs = {
      args: "id:" + this.otSlots.surgery_grade_id
    }
    this.baseService.getData(hasArgs, "", "surgery_grade_master", "facility-management", "GET_BY_ID").subscribe((res) => {
      if (res.errCode == 0 && res.resource) {
        // this.otSlots.surgeryGradeList = res.resource;
        if (res.resource[0] != undefined && res.resource[0].duration_min != undefined) {
          this.otSlots.DurationMin = res.resource[0].duration_min;
          this.otSlots.surgeryGradeDurationMin = this.otSlots.DurationMin * 60 * 1000;
        }
      }
    })
  }

  slotResult(event: any) {
    this.closeModal(event)
  }

  otSlotResult(event: any) {
    event['ot_id'] = this.otSlots.OTId;
    event['ot_name'] = this.otSlots.OTName;
    this.otObject = event;
    this.showButton = true;
  }

  sendPickerResult(event: any) {
    this.otSlots.currentDate = _moment(event.date).subtract(0, 'days').startOf('day').valueOf()
    if (this.otSlots.surgery_grade_id != undefined) {
      this.getAppointsSlots(this.otSlots.currentDate, this.otSlots.OTId);
    }
    if (this.doctor_id != undefined) {
      this.hasDoctorSlots();
    }
    if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.patientData != undefined) {
      this.getMachineSlots(this.otSlots.currentDate, this.otSlots.machineId);
    }
  }

  hasDoctorSlots() {
    this.loader.showSpinner()
    var args = 'practitioner_id:' + this.doctor_id + ',' + 'slot_date:' + this.otSlots.currentDate + ',' + 'slot_days:' + _moment(this.otSlots.currentDate).format("dd").toUpperCase() + ',' + 'serviceItemCode:opd';
    let data = {
      args: args
    }
    let _queryId = "GET_ALL_PRACTITIONER_SLOT_LIST"
    this.baseService.getData(data, '', 'slot', 'facility-management', _queryId).subscribe((res) => {
      this.loader.hideSpinner();
      if (res.errCode == 0) {
        this.doctorSlots = res.resource;
      }
      else {
        this.alert.error(res.message);
      }
    },
      (error) => {
        console.error("Error in getting Data :: ", error);
      }
    )
  }

  closeModal(data) {
    this.dialog.close(data);
  }

  public getOTList() {
    let resource = this.otSlots.getOTListArgs;
    // if (this.otSlots.surgery_type == 'CathLab') {
    //   resource.query_id = "GET_USER_OT";
    //   resource.args.type = "cathlab"
    // }
    // else {
    resource.query_id = "GET_USER_OT";
    resource.args.type = this.dialogConfig.data.surgery_type
    // }
    let data = {
      args: this.otService.getArguments(resource.args)
    }
    this.baseService.getData(data, "", "ot_user_mapping", "ot", resource.query_id).subscribe(
      res => {
        this.OTName = res.resource;
        // this.showButton = false
      }
    )
  }

  public getMachineSlots(date: any, event: any) {
    this.showDateTime = true;
    var slotDate = _moment(date).subtract(0, 'days').startOf('day').valueOf();
    var slotDay = _moment(date).format('dd').toUpperCase();
    var hasArgs = {
      args: "machine_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",serviceItemCode:" + this.machineServiceItemCode,
    }
    this.baseService.getData(hasArgs, "", "slot", "facility-management", "MACHINE_SLOT_LIST").subscribe((slots) => {
      if (slots.errCode == 0 && slots.resource) {
        this.machineSlots = slots.resource;
      }
      else {
        this.machineSlots = []
      }
    })
  }

  public getAppointsSlots(date: any, event: any) {
    this.showButton = false
    var slotDate = _moment(date).subtract(0, 'days').startOf('day').valueOf();
    var slotDay = _moment(date).format('dd').toUpperCase();
    let OTName = this.OTName ? this.OTName.find(x => x.id == event) : '';
    if (OTName && OTName.name) {
      this.otSlots.OTName = OTName.name
    }
    // if (this.otSlots.surgery_type == 'OT') {
    var hasArgs = {
      args: "roomtype_id:" + this.dialogConfig.data.surgery_type + ",ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay + ",care_type:" + this.dialogConfig.data.care_type
    }
    // }
    // else if (this.otSlots.surgery_type == 'CathLab') {
    //   var hasArgs = {
    //     args: "roomtype_id:cathlab,ot_id:" + event + ",slot_date:" + slotDate + ",slot_days:" + slotDay,
    //   }
    // }
    // surgeon-wise OT/Cathlab scheduling: backend marks slots kept for other surgeons as reserved
    if (this.dialogConfig.data && this.dialogConfig.data.surgeon_id) {
      hasArgs.args += ",surgeon_id:" + this.dialogConfig.data.surgeon_id;
    }
    this.baseService.getData(hasArgs, "", "ot_slot", "ot", "OT_SLOT_LIST").subscribe((slots) => {
      if (slots.errCode == 0 && slots.resource) {
        this.otSlots.slots = slots.resource;
      }
      else {
        this.otSlots.slots = []
      }
      this.otSlots.showAcknowledge = true;
      this.otSlots.multipleSlots = true;
    })
  }

  bloodDetail(event) {
    this.bloodData = event.items
  }
  onSubmit() {
    if (this.otObject) {
      this.dialog.close(this.otObject);
    }
    else if (this.finalArray.length > 0) {
      this.dialog.close(this.finalArray);
    }
    else if (this.cArmArray != undefined && this.cArmArray.length > 0) {
      this.dialog.close(this.cArmArray);
    }
    else if (this.bloodData != undefined && this.bloodData.length > 0) {
      this.dialog.close(this.bloodData);
    }
    else
      this.dialog.close();
  }
  eventFired(event: any, compositeArray) {
    let length = compositeArray.items.length;
    this.emitArray.emit(compositeArray.items);
    if (this.machineData != undefined && this.machineData != "" && (compositeArray.items[length - 1].serviceStartTime == '' || compositeArray.items[length - 1].serviceDate == '' || compositeArray.items[length - 1].serviceEndTime == '')) {
      compositeArray.items[length - 1].serviceStartTime = this.machineData.slot_start_time;
      compositeArray.items[length - 1].serviceDate = this.machineData.slot_date;
      compositeArray.items[length - 1].serviceEndTime = this.machineData.slot_end_time;
      this.showDateTime = false
    }
    else if (this.schedulable == true && (this.machineData == undefined || this.machineData == "") && (compositeArray.items[length - 1].serviceStartTime == '' || compositeArray.items[length - 1].serviceDate == '' || compositeArray.items[length - 1].serviceEndTime == '')) {
      this.alert.error("Please Select Slot");
      compositeArray.items.splice(length - 1, 1);
      // compositeArray.items = [];
    }
    this.machineData = "";
    this.finalArray = event.items
  }
}
